module.exports = __webpack_public_path__ + "static/media/tick.c95785be.png";